export const validateEmail = function(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateForm = function(formdata) {
  let caughtErrors = [];
  const email = formdata.email;
  const experience = formdata.experienceDescription;
  //const phonenumber = formdata.phonenumber;
  if (!email && !validateEmail(email)) {
    caughtErrors.push("email");
  }
  if (!formdata.firstname) {
    caughtErrors.push("firstname");
  }
  if (!formdata.lastname) {
    caughtErrors.push("lastname");
  }

  if (experience && experience.length > 400) {
    caughtErrors.push("experienceDescription");
  }
  return caughtErrors;
};



// WEBPACK FOOTER //
// ./src/utils/validation.js